<template>
    <section>
        <div id="logo" @click="logoAction">
            <ds-logo />
        </div>

        <div class="not-found-container">
            <ds-illustration name="oops-color" width="146" height="120" />

            <h1 class="title bold">
                Uh oh, that page doesn't exist.
            </h1>

            <h4 class="subtitle">
                <div>
                    We're not sure what went wrong. You can go <br />
                    back, or visit our <a href="https://help.keap.com/help">
                        <span>
                            Help Center.
                        </span>
                    </a>
                </div>
            </h4>
        </div>
    </section>
</template>

<script>
export default {

    methods: {

        logoAction() {
            window.location.href = 'https://www.keap.com';
        },
    },
};

</script>

<style lang="scss" scoped>
    #logo {
        position: absolute;
        top: 3vh;
        left: 3vh;
        width: 7vh;
        cursor: pointer;
    }

    .sad-browser {
        text-align: center;
    }

    .not-found-container {
        display: flex;
        align-items: center;
        min-height: 85vh;
        justify-content: center;
        flex-direction: column;
    }

    .not-found-container > * {
        margin-top: $spacing-400;

        &:first-child {
            margin-top: inherit;
        }
    }

    .subtitle, .title {
        display: flex;
        justify-content: center;
        text-align: center;
    }

    .title {
        color: $color-gray-900;
        font-family: 'Ivar Soft', sans-serif;
        line-height: 1;
        margin-bottom: $spacing-200;
        margin-top: $spacing-100;
    }

    .subtitle {
        color: $color-gray-800;
        margin-top: $spacing-200;
    }

    .helpText {
        text-align: center;
    }

    .helpLinks {
        display: flex;
        align-items: stretch;
        justify-content: center;
        flex-direction: row;
        text-align: center;

        & > * {
            padding: 0 2vh;

            &:hover, &:visited, &:active, &:link {
                color: $color-ink;
                text-decoration: none;
            }

            & > * {
                cursor: pointer;
                min-width: 20vh;
                border-bottom: .2em solid $color-emerald;
            }
        }
    }
</style>
